<template>
  <div class="container mainContent">
    <h2>About Cape Town</h2>

    <h3>Cape Town – the mother city</h3>
    <p>
      The capital of the Western Cape Province of South Africa, and one of four national capitals, Cape Town is a political, economic, and cultural hub. Cape Town lies along the Cape Peninsula, a region ensconced in mountains, and edged by the Indian and Atlantic oceans. Named the most beautiful city in the world in 2014, Cape Town is perhaps best known for its cultural ambience. Fine dining and the arts flourish in a region bordered by one of the Southern hemisphere’s older wine-growing regions. Cape Town is also home to two of the country’s oldest universities and teaching hospitals, saw the world’s first heart transplant, and – today – is characterised by a rich and lively academic culture. Cape Town is both tourist attraction and local haven, and – with its international airport, is a stepping stone between Africa, and the world.
    </p>

    <h3>Communications</h3>
    <ul>
      <li>Roaming mobile network services are available in South Africa</li>
      <li>If you wish to join a South African mobile network, you can buy or hire a cell phone at the airport or at most of the major shopping centres.</li>
      <li>Internet cafe charges are reasonable.  You will find Internet cafe facilities at some Cape Town Tourism Visitor Information Centres.</li>
      <li>Many hotels and accommodation establishments have wireless internet connections</li>
    </ul>

    <h3>Money</h3>
    <ul>
      <li>The local currency is the South African rand. Foreign exchange facilities are widely available and can be found at the V&amp;A Waterfront, Cape Town International Airport and at bureaux de change in various major shopping centres.</li>
      <li>Automated Teller Machines (ATMs) accept most international bank and credit cards.</li>
      <li>VAT: South Africa has a Value Added Tax system of 14% on purchases and services. Foreign visitors can reclaim VAT on collective purchases of more than R250. VAT Refund Offices can be found at: Ground level, International Departures, Cape Town International Airport Tel: + 27 21 934 8675.</li>
    </ul>

    <h3>Tipping</h3>
    <ul>
      <li>A 10% tip is standard in restaurants. Tables of over eight people often have an automatic service charge added to the bill. A tip of R5 to R10 per piece of luggage is acceptable for porters in hotels and at airports. In some shopping areas, uniformed attendants will either take a fee or offer to mind your car for a tip.</li>
      <li>It is not obligatory to tip an informal ‘car guard’ for services rendered. If you choose to tip, that is permissible, but informal guards are not allowed to ask for money, either before or after the service is supplied. A tip of R1 to R5 is acceptable.</li>
      <li>When parking in metered bays in the CBD (Central Business District), parking marshals wearing luminous bibs will approach you and ask you how long you intend to stay. You can pay by the half-hour in advance, and pay the balance upon your return if necessary. Ignoring the marshal is a popular local pastime, but, then again, so is imposing fines on motorists.</li>
    </ul>

    <h3>Health tips</h3>
    <ul>
      <li>High-quality tap (faucet) water is available across the city and it is both palatable and safe to drink straight from the tap.</li>
      <li>The quality of the food is excellent, and Cape Town has some of the top restaurants in the world.</li>
      <li>Medical facilities in Cape Town are world-class. There is an excellent network of both state and private hospitals.</li>
      <li>We have a warm sunny climate and you should wear sunscreen and a hat whenever you are out of doors during the day, particularly between 10am and 4pm.</li>
      <li>Hepatitis B inoculations are recommended for children up to the age of 12 who have not completed the series of injections as infants.</li>
      <li>Cape Town is not a malaria area.</li>
    </ul>

    <h3>Security tips</h3>
    <ul>
      <li>Avoid carrying large sums of cash, carrying cameras or video cameras in plain sight and leaving belongings unattended.</li>
      <li>Heed the advice of your hosts or locals on where to go after dark. Try not to walk alone.</li>
      <li>Do not allow strangers to assist you in any way at ATMs.</li>
      <li>Street children and beggars may approach you for a handout. Many social workers counsel against giving money to the children as it usually gets handed over to an older person or is used to purchase drugs.</li>
      <li>At night, park in a secure, well-lit area.
    </ul>

    <h3>Language</h3>
    <p>
      While the most commonly spoken language in Cape Town is Afrikaans, English is most commonly understood.
    </p>
    <p>
      But, as English is only one of South Africa’s 11 official languages, a strong vernacular has developed, and English-speaking visitors might have a hard time recognising some of the words. We’re a friendly bunch in Cape Town, so if you’re totally confused, just ask and we’ll have you speaking South African.
    </p>
  </div>

</template>

<script>
  export default {
    name: "info_capetown"
  }
</script>



/** WEBPACK FOOTER **
 ** info_capetown.vue?388db231
 **/